import React, {FunctionComponent} from 'react';
import './CartModifier.less';
import {CartModifierName} from 'elements/cart-modifier-name/CartModifierName';
import {CartModifierPrice} from 'elements/cart-modifier-price/CartModifierPrice';

interface CartModifierProps {
	name: string,
	price?: number | string
}

export const CartModifier: FunctionComponent<CartModifierProps> = ({name, price}) => {
	return (
		<div className="cart-modifier">
      <span className="cart-modifier__name">
        <CartModifierName text={name}/>
      </span>
			{
				(typeof price === 'number' || typeof price === 'string') && (
					<span className="cart-modifier__price">
                    <CartModifierPrice price={price}/>
                </span>
				)
			}
		</div>
	);
};
